import { createApi } from "@reduxjs/toolkit/query/react";
import { enhancedBaseQuery } from "./baseQuery.js";
import apiConfig from "../../config/api.config.js";
import { authEndpoints } from "./endpoints/authApi.js";
import { userEndpoints } from "./endpoints/userApi.js";
import { postsEndpoints } from "./endpoints/postsApi.js";
import { mockHandlers } from "../mock/handlers.js";

// Create the API
export const api = createApi({
  reducerPath: "api",
  baseQuery: enhancedBaseQuery,
  tagTypes: ["User", "Users"],
  endpoints: () => ({
    // Empty initial endpoints - will be injected from slices
  }),
  // Add middleware to handle failed requests
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(() => (next) => (action) => {
      // Log rejected API actions with 502 errors
      if (action.type.endsWith('/rejected') && action.payload?.status === 502) {
        console.warn('API Server Unreachable (502 Error):', action);
        console.info('Consider enabling mock mode in development to prevent 502 errors');
      }
      return next(action);
    }),
});

// Inject posts and stats endpoints (always available regardless of mock mode)
api.injectEndpoints({
  endpoints: postsEndpoints,
  overrideExisting: false,
});

// Conditionally inject endpoints based on mock mode
if (apiConfig.enableMock) {
  console.log("Using mock API handlers");

  // Inject mock API handlers
  api.injectEndpoints({
    endpoints: mockHandlers,
    overrideExisting: true,
  });
} else {
  // Inject real API endpoints
  api.injectEndpoints({
    endpoints: authEndpoints,
    overrideExisting: false,
  });

  api.injectEndpoints({
    endpoints: userEndpoints,
    overrideExisting: false,
  });
}

// Export hooks
export const {
  // Auth endpoints
  useLoginMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,

  // User endpoints
  useGetCurrentUserQuery,
  useUpdateProfileMutation,
  useGetUsersQuery,

  // Posts endpoints
  useGetPostsQuery,
  useGetPostQuery,
} = api;
